import { React, useEffect, useState } from "react";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import ProductThumbNailGroup from "../ProductThumbNailGroup/ProductThumbNailGroup";
import AddToCart from "../AddToCart/AddToCart";
import BestGear from "../BestGear/BestGear";
import AlsoLike from "../AlsoLike/AlsoLike";

import Footer from "../Footer/Footer";
import Features from "../Features/Features";
import marktwo from "../../assets/product-xx99-mark-two-headphones/desktop/image-product.jpg";
import marktwoTab from "../../assets/product-xx99-mark-two-headphones/tablet/image-product.jpg";
import marktwoMobile from "../../assets/product-xx99-mark-two-headphones/mobile/image-product.jpg";
import markOne from "../../assets/shared/desktop/image-xx99-mark-one-headphones.jpg";
import markOneTab from "../../assets/shared/tablet/image-xx99-mark-one-headphones.jpg";
import markOneMobile from "../../assets/shared/mobile/image-xx99-mark-one-headphones.jpg";
import speaker from "../../assets/shared/desktop/image-zx9-speaker.jpg";
import speakerTab from "../../assets/shared/tablet/image-zx9-speaker.jpg";
import speakerMobile from "../../assets/shared/mobile/image-zx9-speaker.jpg";
import xx59 from "../../assets/shared/desktop/image-xx59-headphones.jpg";
import xx59Tab from "../../assets/shared/tablet/image-xx59-headphones.jpg";
import xx59Mobile from "../../assets/shared/mobile/image-xx59-headphones.jpg";
import ProductGallery from "../ProductGallery/ProductGallery";
import imgGallery1 from "../../assets/product-xx99-mark-two-headphones/desktop/image-gallery-1.jpg";
import imgGallery2 from "../../assets/product-xx99-mark-two-headphones/desktop/image-gallery-2.jpg";
import imgGallery3 from "../../assets/product-xx99-mark-two-headphones/desktop/image-gallery-3.jpg";

const HeadphonesMarkTwo = ({
  addMarkTwoToCart,
  cart,
  updateMyCart,
  updateQuantity,
  increment,
  decrement,
  quantity,
}) => {
  const [markTwoImg, setMarkTwoImg] = useState("");
  const [markOneURL, setMarkOneURL] = useState("");
  const [speakerURL, setSpeakerURL] = useState("");
  const [xx59URL, setxx59URL] = useState("");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 450) {
        setMarkTwoImg(marktwoMobile);
        setMarkOneURL(markOneMobile);
        setSpeakerURL(speakerMobile);
        setxx59URL(xx59Mobile);
      } else if (window.innerWidth <= 768) {
        setMarkTwoImg(marktwoTab);
        setMarkOneURL(markOneTab);
        setSpeakerURL(speakerTab);
        setxx59URL(xx59Tab);
      } else {
        setMarkTwoImg(marktwo);
        setMarkOneURL(markOne);
        setSpeakerURL(speaker);
        setxx59URL(xx59);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <>
      <HeaderB
        cart={cart}
        updateCartQuantity={updateQuantity}
        increment={increment}
        decrement={decrement}
        quantity={quantity}
      />
      <main>
        <GoBackLink />
        <AddToCart
          imageURL={markTwoImg}
          productName={
            <>
              XX99 Mark II <br /> Headphones
            </>
          }
          description="The new XX99 Mark II headphones is the pinnacle of pristine audio. It redefines your 
          premium headphone experience by reproducing the balanced depth and precision of 
          studio-quality sound."
          price="2999"
          addItem={updateMyCart}
          updateQuantity={updateQuantity}
          quantity={quantity}
          increment={increment}
          decrement={decrement}
        />
        <Features
          p1=" Featuring a genuine leather head strap and premium earcups, these headphones deliver superior 
  comfort for those who like to enjoy endless listening. It includes intuitive controls designed 
  for any situation. Whether you’re taking a business call or just in your own personal space, the 
  auto on/off and pause features ensure that you’ll never miss a beat."
          p2="The advanced Active Noise Cancellation with built-in equalizer allow you to experience your audio 
  world on your terms. It lets you enjoy your audio in peace, but quickly interact with your surroundings 
  when you need to. Combined with Bluetooth 5. 0 compliant connectivity and 17 hour battery life, the 
  XX99 Mark II headphones gives you superior sound, cutting-edge technology, and a modern design aesthetic. "
        />
        <ProductGallery image={[imgGallery1, imgGallery2, imgGallery3]} />
        <AlsoLike
          image={[markOneURL, xx59URL, speakerURL]}
          title={["XX99 MARK I", "XX59", "ZX9 SPEAKER"]}
          nav1={"/headphones/markOne"}
          nav2={"/headphones/xx59"}
          nav3={"/speakerZx9"}
        />
        <ProductThumbNailGroup />
        <BestGear />
        <Footer />
      </main>
    </>
  );
};

export default HeadphonesMarkTwo;
